module.exports = __webpack_public_path__ + "static/media/forgetotp.7b453531.png";